"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    d: "M2 2v20h1V2H2zm4 20V2h1v20H6zm4 0V2h1v20h-1zm4-16h1.0625V4H14v2zm4.0625 6c0 2.2437-1.8188 4.0625-4.0625 4.0625v-2.125c1.0701 0 1.9375-.8674 1.9375-1.9375S15.0701 10.0625 14 10.0625v-2.125c2.2437 0 4.0625 1.8188 4.0625 4.0625zm-3 8H14v-2h1.0625v2zm3.8522-14.4173L17.2242 7.273l1.5026 1.5026 1.6905-1.6904-1.5026-1.5026zM22 10.9375h-2v2.125h2v-2.125zm-1.5827 5.9773-1.6905-1.6904-1.5026 1.5026 1.6905 1.6904 1.5026-1.5026z"
  })];
};

exports.default = _default;